import options from './measure.directive';

export default {
    selector: 'dtMeasure',
    options
};
